import { compose } from 'redux';
import { rules, addError } from 'components/Form/validation';

import { countriesWithExtraInfo } from 'lib/countries';

export const ACCEPTED_FILE_TYPES = ['image/png', 'image/jpg', 'image/jpeg', 'image/bmp'];
export const INVALID_FILE_TYPE = 'invalid_file_type';
export const INVALID_FILE_SIZE = 'invalid_file_size';
export const MAX_FILE_SIZE_MB = 10;

const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

const fields = {
  name: 'name',
  country: 'country',
  registration_number: 'registration_number',
  vat_number: 'vat_number',
  picture: 'picture',
};

const createCompanyValidator = (values) => (errors, fieldName) => {
  const val = values.get(fieldName, '');
  const country = values.get('country', '');
  const isRequiredExtraData = countriesWithExtraInfo.includes(country);

  switch (fieldName) {
    case fields.name:
      return compose(addError(fieldName, rules.required(val)))(errors);

    case fields.country:
      return compose(addError(fieldName, rules.required(val)))(errors);

    case fields.registration_number:
      if (isRequiredExtraData) {
        return compose(addError(fieldName, rules.required(val)))(errors);
      }
      return errors;

    case fields.vat_number:
      if (isRequiredExtraData) {
        return compose(addError(fieldName, rules.required(val)))(errors);
      }
      return errors;

    case fields.picture:
      if (val && val.type) {
        const isValidFileType = ACCEPTED_FILE_TYPES.includes(val.type);
        if (!isValidFileType) {
          return compose(addError(fieldName, INVALID_FILE_TYPE))(errors);
        }

        if (val.size > MAX_FILE_SIZE_BYTES) {
          return compose(addError(fieldName, INVALID_FILE_SIZE))(errors);
        }
      }
      return errors;

    default:
      return errors;
  }
};

export const createCompanyValidate = (values) => Object.values(fields).reduce(createCompanyValidator(values), {});
